var map = {
	"./": 137,
	"./Clutch": 2693,
	"./Clutch.js": 2693,
	"./NewUi": 2694,
	"./NewUi.js": 2694,
	"./OldUi": 2695,
	"./OldUi.js": 2695,
	"./index": 137,
	"./index.js": 137,
	"./style": 856,
	"./style.js": 856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4219;